export function FilledNote({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.34639 5.71484L5.34444 5.7207L4.52803 9.21289C4.04826 11.2673 4.12007 13.0229 4.98018 14.4121C5.71962 15.6063 6.96213 16.3995 8.60127 16.9092C7.26511 17.2794 6.36655 17.2301 5.71651 16.8975C5.04192 16.5522 4.45552 15.8119 3.96065 14.415L3.86299 14.127L2.79659 10.835C2.28605 9.2508 2.30694 8.22433 2.67354 7.50391C3.0332 6.79729 3.82595 6.1878 5.3542 5.68262L5.34639 5.71484Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M9.77492 3.00537C10.3794 2.7968 11.1808 2.76886 12.2632 2.97607L12.7437 3.07959L12.7456 3.08057L14.1382 3.40576V3.40479C15.8114 3.7962 16.7129 4.36564 17.1577 5.08252C17.5748 5.75478 17.6963 6.72827 17.3872 8.22314L17.3198 8.52881L16.5034 12.0122L16.5025 12.0132C16.1677 13.452 15.698 14.3252 15.1167 14.8228C14.6301 15.2392 13.98 15.4637 13.0415 15.438L12.6216 15.4116L12.6099 15.4106L12.3237 15.3813C12.1284 15.3569 11.9231 15.3221 11.7075 15.2778L11.3755 15.2046L11.3736 15.2036L9.97414 14.8706H9.97316C8.30757 14.4752 7.40698 13.9059 6.96144 13.189C6.54437 12.5175 6.42055 11.5457 6.72902 10.0522L6.7964 9.74658L6.79738 9.74561L7.61378 6.25537C7.73328 5.74753 7.86673 5.30693 8.01711 4.93311L8.17336 4.58057L8.17531 4.57666C8.59612 3.70626 9.11902 3.23173 9.77492 3.00537Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
